import { GarageTypeContainer } from '../../containers/advancedFilters/GarageTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const garageType: IFilter = {
  component: GarageTypeContainer,
};
